import { EncryptStorage } from "encrypt-storage";

// utils/fetchImage.js
export async function fetchImageUrl({ imagePath }) {
    const encryptStorage = new EncryptStorage(process.env.REACT_APP_SECRET_KEY);
    const userInfo = encryptStorage.getItem("___info");
    const accessToken = userInfo?.token || "";
    const apiKey = "ysadflkasndfwryfwrkfjbwrflsu";
    const baseUrl = process.env.REACT_APP_SERVICE_IMAGE
    try {
        // console.log("🔄 Mengambil gambar...");
        const encodedPath = encodeURIComponent(imagePath);

        const response = await fetch(
            `${baseUrl}/minio/file-url-person?path=${encodedPath}`,
            {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "x-api-key": apiKey,
                },
            }
        );
        const data = await response.json();
        // console.log("Data respons:", data);
        // console.log(response, 'response')

        if (!response.ok) {
            const text = await response.text();
            console.error("❌ Body (error):", text);
            throw new Error(`Gagal mengambil gambar: ${response.status}`);
        }

        return data;
    } catch (err) {
        console.error("🔥 Terjadi error:", err);
        throw err;
    }
}
// export async function fetchImageUrl({ imagePath }) {
//     const encryptStorage = new EncryptStorage(process.env.REACT_APP_SECRET_KEY);
//     const userInfo = encryptStorage.getItem("___info");
//     const accessToken = userInfo?.token || "";
//     const apiKey = "ysadflkasndfwryfwrkfjbwrflsu";
//     const baseUrl = process.env.REACT_APP_SERVICE_IMAGE
//     try {
//         console.log("🔄 Mengambil gambar...");
//         const encodedPath = encodeURIComponent(imagePath);
//         // console.log(`${baseUrl}/minio/file-url-person?path=${encodedPath}`)

//         const response = await fetch(
//             `${baseUrl}/minio/file-url-person?path=${encodedPath}`,
//             {
//                 method: "GET",
//                 headers: {
//                     Authorization: `Bearer ${accessToken}`,
//                     "x-api-key": apiKey,
//                 },
//             }
//         );

//         // console.log("✅ Response status:", response.status);
//         // console.log("✅ Response headers:", [...response.headers.entries()]);

//         if (!response.ok) {
//             const text = await response.text();
//             console.error("❌ Body (error):", text);
//             throw new Error(`Gagal mengambil gambar: ${response.status}`);
//         }

//         const contentType = response.headers.get("Content-Type");
//         if (!contentType || !contentType.startsWith("image/")) {
//             const text = await response.text();
//             console.warn("⚠️ Bukan gambar, isi respons:", text);
//             throw new Error("Response bukan gambar.");
//         }

//         const blob = await response.blob();
//         const objectURL = URL.createObjectURL(blob);
//         console.log("🎉 Gambar berhasil di-fetch dan ditampilkan.");

//         return objectURL;
//     } catch (err) {
//         console.error("🔥 Terjadi error:", err);
//         throw err;
//     }
// }
